import { InjectionToken } from '@angular/core';
import {
    FileExplorerEntry,
    FileExplorerListResponse,
    FileExplorerFileInfo,
    FileExplorerReadResponse
} from './api.service';

/**
 * Injection token for IFileExplorerService
 */
export const FILE_EXPLORER_SERVICE = new InjectionToken<IFileExplorerService>('FILE_EXPLORER_SERVICE');

/**
 * Abstract interface for file explorer operations.
 * Allows swapping implementations (device direct vs cloud tunnel).
 */
export interface IFileExplorerService {
    /**
     * List directory contents
     * @param path Relative path from root
     */
    fileExplorerListDir(path: string): Promise<FileExplorerListResponse>;

    /**
     * Read file contents for preview
     * @param path Relative path from root
     * @param maxBytes Maximum bytes to read
     */
    fileExplorerReadFile(path: string, maxBytes?: number): Promise<FileExplorerReadResponse>;

    /**
     * Get file metadata without reading content
     * @param path Relative path from root
     */
    fileExplorerGetFileInfo(path: string): Promise<FileExplorerFileInfo>;

    /**
     * Download a file (returns base64 encoded content)
     * @param path Relative path from root
     */
    fileExplorerDownloadFile(path: string): Promise<FileExplorerReadResponse>;

    /**
     * Delete a file
     * @param path Relative path from root
     */
    fileExplorerDeleteFile(path: string): Promise<{ success: boolean; error?: string; path?: string; message?: string }>;

    /**
     * Save/write file content
     * @param path Relative path from root
     * @param content File content to save
     */
    fileExplorerSaveFile(path: string, content: string): Promise<{ success: boolean; error?: string; path?: string; name?: string; sizeBytes?: number; modifiedUtc?: string; message?: string }>;

    /**
     * Upload a file to a folder
     * @param folderPath Relative folder path from root
     * @param file File to upload
     */
    fileExplorerUploadFile(folderPath: string, file: File): Promise<{ success: boolean; error?: string; path?: string; name?: string; sizeBytes?: number; extension?: string; message?: string }>;
}
